export default __webpack_public_path__ + "static/media/haup-loading.37fc7742.gif";